import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step6ExamCenter = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    
    // Lists
    const [stateList, setStateList] = useState([]);
    const [cities1, setCities1] = useState([]);
    const [cities2, setCities2] = useState([]);
    const [cities3, setCities3] = useState([]);
    const [cities4, setCities4] = useState([]);

    const [formData, setFormData] = useState({
        applyFor: 'CUET UG',
        qpMedium: '0', // 01=English, 02=Hindi, etc.
        selectedSubjects: [], // Array of subject codes
        center1State: '0', center1City: '0',
        center2State: '0', center2City: '0',
        center3State: '0', center3City: '0',
        center4State: '0', center4City: '0',
        captcha: ''
    });

    // Subject List (Extracted from your HTML)
    const subjects = [
        { code: "101", name: "English (Language)" },
        { code: "102", name: "Hindi (Language)" },
        { code: "103", name: "Assamese (Language)" },
        { code: "104", name: "Bengali (Language)" },
        { code: "301", name: "Accountancy / Book Keeping (Domain)" },
        { code: "302", name: "Agriculture (Domain)" },
        { code: "304", name: "Biology/Biotechnology (Domain)" },
        { code: "305", name: "Business Studies (Domain)" },
        { code: "306", name: "Chemistry (Domain)" },
        { code: "308", name: "Computer Science / IP (Domain)" },
        { code: "309", name: "Economics (Domain)" },
        { code: "314", name: "History (Domain)" },
        { code: "319", name: "Mathematics (Domain)" },
        { code: "322", name: "Physics (Domain)" },
        { code: "323", name: "Political Science (Domain)" },
        { code: "324", name: "Psychology (Domain)" },
        { code: "326", name: "Sociology (Domain)" },
        { code: "501", name: "General Aptitude Test" }
    ];

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const stateRes = await api.get('/mock-cuet/states');
                if (stateRes.data.success) setStateList(stateRes.data.data);

                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const db = res.data.data;
                    
                    // Parse JSON subjects if string, else use direct
                    let subjs = [];
                    if (typeof db.selected_subjects === 'string') {
                        subjs = JSON.parse(db.selected_subjects);
                    } else if (Array.isArray(db.selected_subjects)) {
                        subjs = db.selected_subjects;
                    }

                    setFormData(prev => ({
                        ...prev,
                        qpMedium: db.question_paper_medium || '0',
                        selectedSubjects: subjs || [],
                        center1State: db.exam_center_1_state || '0',
                        center1City: db.exam_center_1_city || '0',
                        center2State: db.exam_center_2_state || '0',
                        center2City: db.exam_center_2_city || '0',
                        center3State: db.exam_center_3_state || '0',
                        center3City: db.exam_center_3_city || '0',
                        center4State: db.exam_center_4_state || '0',
                        center4City: db.exam_center_4_city || '0',
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    // Dynamic City Fetchers
    const fetchCities = async (stateCode, setCityFunc) => {
        if (!stateCode || stateCode === '0') { setCityFunc([]); return; }
        try {
            const res = await api.get(`/mock-cuet/districts/${stateCode}`);
            if (res.data.success) setCityFunc(res.data.data);
        } catch (e) {}
    };

    useEffect(() => { fetchCities(formData.center1State, setCities1); }, [formData.center1State]);
    useEffect(() => { fetchCities(formData.center2State, setCities2); }, [formData.center2State]);
    useEffect(() => { fetchCities(formData.center3State, setCities3); }, [formData.center3State]);
    useEffect(() => { fetchCities(formData.center4State, setCities4); }, [formData.center4State]);

    // Handlers
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubjectChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prev => {
            let newSubs = [...prev.selectedSubjects];
            if (checked) {
                if (newSubs.length >= 10) { alert("Maximum 10 subjects allowed"); return prev; }
                newSubs.push(value);
            } else {
                newSubs = newSubs.filter(code => code !== value);
            }
            return { ...prev, selectedSubjects: newSubs };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.selectedSubjects.length === 0) {
            alert("Please select at least one Test Paper");
            return;
        }

        setLoading(true);
        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 6,
                stepData: formData,
                nextStepNumber: 7
            });

            if (res.data.success) {
                refreshUser(7);
                navigate('/services/counselling/dashboard/qualification-details');
            }
        } catch (err) {
            alert("Error saving data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div id="ctl00_ContentPlaceHolder1_pnlApplyForDetails">
                    <h4>
                        <span id="ctl00_ContentPlaceHolder1_lblApplyForSectionHeader">परीक्षा के लिए चयन करें (Select for Exam)</span>
                    </h4>
                    
                    <div className="form-horizontal formLabel">
                        {/* Static Info Box */}
                        <div className="form-group bg-warning text-danger" style={{ textAlign: 'justify', padding: '10px', margin: '0 0 15px 0' }}>
                            <div className="col-sm-12">
                                <strong>Note -</strong> You can choose a maximum 05 Test Papers including Languages and General Aptitude Test.
                            </div>
                        </div>

                        {/* Apply For */}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>परीक्षा के लिए चयन करें (Select for Exam)</span>
                            </label>
                            <div className="col-sm-4">
                                <select className="form-control" disabled>
                                    <option>CUET UG</option>
                                </select>
                            </div>
                        </div>

                        {/* Subjects Checkboxes */}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>परीक्षण पत्र (Test Papers)</span>
                            </label>
                            <div className="col-sm-6">
                                <div style={{ borderColor: '#CCCCCC', borderWidth: '2px', borderStyle: 'Solid', overflowY: 'scroll', maxHeight: '200px', borderRadius: '4px', padding: '5px' }}>
                                    <table border="0">
                                        <tbody>
                                            {subjects.map(sub => (
                                                <tr key={sub.code}>
                                                    <td>
                                                        <div className="checkbox" style={{margin:0}}>
                                                            <label>
                                                                <input 
                                                                    type="checkbox" 
                                                                    value={sub.code} 
                                                                    checked={formData.selectedSubjects.includes(sub.code)}
                                                                    onChange={handleSubjectChange}
                                                                /> {sub.code} - {sub.name}
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Medium */}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>प्रश्न पत्र का माध्यम (Question Paper Medium)</span>
                            </label>
                            <div className="col-sm-4">
                                <select name="qpMedium" className="form-control" value={formData.qpMedium} onChange={handleChange} required>
                                    <option value="0">--Select--</option>
                                    <option value="01">English</option>
                                    <option value="02">Hindi</option>
                                    <option value="03">Assamese</option>
                                    <option value="04">Bengali</option>
                                    <option value="05">Gujarati</option>
                                </select>
                            </div>
                        </div>

                        <br />
                        
                        {/* Exam Centers - Repeated Block logic */}
                        {[1, 2, 3, 4].map(num => (
                            <div className="form-group" key={num}>
                                <label className="control-label col-sm-4">
                                    <span>परीक्षा राज्य / शहर- विकल्प {num} (Exam City Choice {num})</span>
                                </label>
                                <div className="col-sm-4">
                                    <select 
                                        name={`center${num}State`} 
                                        className="form-control" 
                                        value={formData[`center${num}State`]} 
                                        onChange={handleChange}
                                        style={{marginBottom: '5px'}}
                                    >
                                        <option value="0">--Select State--</option>
                                        {stateList.map((st) => (
                                            <option key={st.state_code} value={st.state_code}>{st.state_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-sm-4">
                                    <select 
                                        name={`center${num}City`} 
                                        className="form-control" 
                                        value={formData[`center${num}City`]} 
                                        onChange={handleChange}
                                    >
                                        <option value="0">--Select City--</option>
                                        {/* Use specific city list based on num */}
                                        {(num === 1 ? cities1 : num === 2 ? cities2 : num === 3 ? cities3 : cities4).map((dist) => (
                                            <option key={dist.district_code} value={dist.district_code}>{dist.district_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ))}

                        <br />

                        {/* Captcha & Submit */}
                        <div id="ctl00_ContentPlaceHolder1_pnlFinalSubmit">
                            <h4>CAPTCHA</h4>
                            <div className="form-group">
                                <label className="control-label col-sm-4">Enter Security Pin</label>
                                <div className="col-sm-4">
                                    <input name="captcha" type="text" className="form-control" value={formData.captcha} onChange={handleChange} required />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-4">CAPTCHA</label>
                                <div className="col-sm-4">
                                    <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px'}} />
                                </div>
                            </div>
                            
                            <div className="form-group text-center" style={{marginTop:'20px'}}>
                                <button type="button" className="btn btn-warning" onClick={() => navigate('/services/counselling/dashboard/apaar-id')} style={{marginRight:'10px'}}>
                                    Back
                                </button>
                                <button type="submit" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                                    {loading ? 'Saving...' : 'Save & Next'}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step6ExamCenter;